// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Sk4I","signatureBlock":"Footer_signatureBlock__1Bebq","signature":"Footer_signature__3zkMn"};